import type { User } from "@/types/user"

type UserIdentity = Partial<Pick<User, "username" | "email">>

/**
 * The name shown for a user. Cognito often uses the email as the username, so
 * an email-like name is shortened to its local part.
 */
export function userDisplayName(user: UserIdentity): string {
  const raw = user.username || user.email || ""
  return raw.includes("@") ? raw.split("@")[0] : raw
}

/** The user's email address; with an email-like username, `email` may be
 *  empty and the username is the address. */
export function userEmail(user: UserIdentity): string {
  return user.email || (user.username?.includes("@") ? user.username : "")
}

/** Up to two initials, one per part of the name ("ada.lovelace" → "AL"). */
export function userInitials(name: string): string {
  const initials = name
    .split(/[\s._@-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("")
  return initials || "?"
}
